export const classes = {
  listItem:
    'flex items-center cursor-pointer select-none rounded-lg mx-1 my-0.5 px-3 py-2 text-taupe-3 hover:bg-black/5',
  destructive: 'text-red-3 hover:bg-red-2/10',
  label: 'text-sm font-medium',
  icon: 'mr-3 h-[1.125rem] w-[1.125rem] text-taupe-2',
  destructiveIcon: 'text-red-3',
};
